import { render, staticRenderFns } from "./NavigationTabBar.vue?vue&type=template&id=782483ee&scoped=true&"
import script from "./NavigationTabBar.vue?vue&type=script&lang=ts&"
export * from "./NavigationTabBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782483ee",
  null
  
)

export default component.exports